<body>
  <div class="card-body">
    <div class="card-contents">
      <div class="card-header">Create Password</div>
      <div class="form-text">Enter and confirm your desired password </div>
      <app-password-confirmation (passwordSubmit)="onPasswordSubmit($event)" id="password-field">
      </app-password-confirmation>
    </div>
  </div>
</body>